import { faLocationDot } from '@fortawesome/pro-solid-svg-icons/faLocationDot'
import { Box, type BoxProps } from '@mantine/core'
import clsx from 'clsx'
import GoogleMapReact from 'google-map-react'
import { type PropsWithChildren } from 'react'

import { Icon } from '../../src'
import {
  DEFAULT_REGION,
  DEFAULT_LOCALE,
  GOOGLE_MAPS_API_KEY,
  PORTUGAL,
} from './constants'
import styles from './styles.module.css'
import type { MarkerInfo } from './types'

export type BoxGoogleMapsMarkerInfo = MarkerInfo

export type BoxGoogleMapsProps = PropsWithChildren<BoxProps> & {
  markers: MarkerInfo[]
  defaultZoom?: number
  defaultCenter?: GoogleMapReact.Coords
}

export function BoxGoogleMaps({
  markers,
  defaultZoom = 13,
  defaultCenter = PORTUGAL,
  children,
  ...props
}: BoxGoogleMapsProps) {
  const classes = clsx(styles.wrapper, props.className)
  return (
    <Box h={500} {...props} className={classes}>
      {children}
      {/* @ts-expect-error GoogleMapReact without types */}
      <GoogleMapReact
        defaultZoom={defaultZoom}
        defaultCenter={defaultCenter}
        center={markers[0]}
        bootstrapURLKeys={{
          key: GOOGLE_MAPS_API_KEY,
          region: DEFAULT_REGION,
          language: DEFAULT_LOCALE,
          libraries: 'places',
        }}
      >
        {markers
          .filter((marker) => marker.show)
          .map((marker, key) => (
            <Box
              key={`box-google-maps-maker-${key.toString()}`}
              {...marker}
              data-testid='box-google-maps-marker'
            >
              <Icon className={styles.marker} icon={faLocationDot} />
            </Box>
          ))}
      </GoogleMapReact>
    </Box>
  )
}
